/**
 * @generated SignedSource<<f41787ed8891f59965bf81992bafd523>>
 * @relayHash ad47b3c660f7b38519caeea7b1b2815c
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID ad47b3c660f7b38519caeea7b1b2815c

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "file"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "src"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "file",
        "variableName": "file"
      },
      {
        "kind": "Variable",
        "name": "src",
        "variableName": "src"
      }
    ],
    "concreteType": "UpdateContractFromOmgFeedbackCsvTaskMutationResponse",
    "kind": "LinkedField",
    "name": "updateContractFromOmg",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateContractFromOMGMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateContractFromOMGMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "ad47b3c660f7b38519caeea7b1b2815c",
    "metadata": {},
    "name": "UpdateContractFromOMGMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

node.hash = "96b369adfa34f0c7a9bf7fccc6ce0968";

export default node;
